import { AgentToolCallStatus } from './runs.js';
import { ProposalDecision } from './types.js';
export const MAX_LISTED_PERFORMANCE_PROPOSALS = 100;
const decisionByStatus = {
    [AgentToolCallStatus.Proposed]: ProposalDecision.Pending,
    [AgentToolCallStatus.Executing]: ProposalDecision.Pending,
    [AgentToolCallStatus.Rejected]: ProposalDecision.Rejected,
    [AgentToolCallStatus.Failed]: ProposalDecision.Failed,
    [AgentToolCallStatus.Stale]: ProposalDecision.Closed,
    [AgentToolCallStatus.Superseded]: ProposalDecision.Closed,
    [AgentToolCallStatus.Dismissed]: ProposalDecision.Closed,
};
export const proposalDecisionOf = (status, wasEdited) => {
    if (status !== AgentToolCallStatus.Executed) {
        return decisionByStatus[status];
    }
    return wasEdited ? ProposalDecision.Edited : ProposalDecision.ApprovedAsIs;
};
export const emptyDecisionCounts = () => ({
    [ProposalDecision.Pending]: 0,
    [ProposalDecision.ApprovedAsIs]: 0,
    [ProposalDecision.Edited]: 0,
    [ProposalDecision.Rejected]: 0,
    [ProposalDecision.Failed]: 0,
    [ProposalDecision.Closed]: 0,
});
export const proposalCount = (counts) => Object.values(counts).reduce((sum, count) => sum + count, 0);
// Decisions where a caseworker judged the content.
export const JUDGED_DECISIONS = [
    ProposalDecision.ApprovedAsIs,
    ProposalDecision.Edited,
    ProposalDecision.Rejected,
];
// Share of judged proposals; null until at least one proposal was judged.
export const decisionShare = (counts, decision) => {
    const judged = JUDGED_DECISIONS.reduce((sum, judgedDecision) => sum + counts[judgedDecision], 0);
    return judged === 0 ? null : counts[decision] / judged;
};
//# sourceMappingURL=performance.js.map